// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info_links__BYFlA {
  display: flex;
  gap: 40px;
  margin-top: 44px; }
  .info_links__BYFlA a {
    color: #FE6100;
    text-decoration: none;
    transition: all 0.3s; }
    .info_links__BYFlA a:hover {
      border-bottom: 1px solid #FE6100;
      border-bottom-color: #FE6100; }

.info_algorithms_title__0nYQl {
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--LowEmphasis);
  margin-bottom: 10px; }

.info_version__\\+ZQH7 {
  display: flex;
  flex-direction: column;
  gap: 10px; }
  .info_version_row__QJ13K {
    color: #666666;
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 5px; }
    .info_version_row_title__XVsi- {
      color: #212121;
      min-width: calc(50% - 30px);
      max-width: calc(50% - 30px);
      font-weight: 600;
      font-size: 16px;
      line-height: 24px; }
    .info_version_row_text__GyFr0 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-right: 20px; }
  .info_version_app__HwfEa {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--HightEmphasis);
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
    padding: 10px; }
    .info_version_app__HwfEa h3 {
      font-weight: 700;
      font-size: 18px;
      line-height: 150%;
      margin-bottom: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/info/version/info.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB,EAAA;EAHlB;IAKI,cAAc;IACd,qBAAqB;IACrB,oBAAoB,EAAA;IAPxB;MASM,gCAAgC;MAChC,4BAA4B,EAAA;;AAKlC;ECuDE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDvDjB,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EACT;IACE,cAAc;IACd,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAA;IACnB;MACE,cAAc;MACd,2BAA2B;MAC3B,2BAA2B;MAC3B,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAEnB;MACE,WAAW;MACX,aAAa;MACb,8BAA8B;MAC9B,mBACF,EAAA;EAEF;ICdA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDcf,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa,EAAA;IANd;MAQG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,mBAAmB,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.links {\n  display: flex;\n  gap: 40px;\n  margin-top: 44px;\n  & a {\n    color: #FE6100;\n    text-decoration: none;\n    transition: all 0.3s;\n    &:hover {\n      border-bottom: 1px solid #FE6100;\n      border-bottom-color: #FE6100;\n    }\n  }\n}\n\n.algorithms_title {\n  @include title;\n  color: var(--LowEmphasis);\n  margin-bottom: 10px;\n}\n\n.version {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  &_row {\n    color: #666666;\n    display: flex;\n    border-bottom: 1px solid #e0e0e0;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    padding-bottom: 5px;\n    &_title {\n      color: #212121;\n      min-width: calc(50% - 30px);\n      max-width: calc(50% - 30px);\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n    }\n    &_text{\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      padding-right: 20px\n    }\n  }\n  &_app {\n    @include body1;\n    color: var(--HightEmphasis);\n    margin-bottom: 20px;\n    background: #ffffff;\n    box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n    padding: 10px;\n    h3 {\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 150%;\n      margin-bottom: 20px;\n    }\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"links": `info_links__BYFlA`,
	"algorithms_title": `info_algorithms_title__0nYQl`,
	"version": `info_version__+ZQH7`,
	"version_row": `info_version_row__QJ13K`,
	"version_row_title": `info_version_row_title__XVsi-`,
	"version_row_text": `info_version_row_text__GyFr0`,
	"version_app": `info_version_app__HwfEa`
};
export default ___CSS_LOADER_EXPORT___;
